import React from 'react';
import { Link } from "react-router-dom";
import { FaLightbulb, FaShieldAlt, FaTrophy, FaUsers } from 'react-icons/fa';

const AboutSection = () => (
  <section className="container py-3 mb-4">
    <div className="row g-5 align-items-center">
      {/* Left Text Content */}
      <div className="col-lg-6">
        <p className="d-inline-block border rounded fw-semibold py-1 px-3 text-navyblue">
          <FaUsers className='me-2' /> About Us
        </p>
        <h1 className="display-5 mb-4 text-navyblue">
          Why Clients Choose Us!
        </h1>
        <p className="mb-4 text-dark">
          We are committed to delivering excellence by embracing innovation,
          upholding integrity, and striving for outstanding quality in every
          project we undertake.
        </p>
        <Link to='/about'>
          <button className="btn-custom py-3 px-5 rounded-5">
            Explore More
          </button>
        </Link>
      </div>

      {/* Right Core Values Cards */}
      <div className="col-lg-6">
        <div className="row g-4 align-items-center">
          <div className="col-md-6">
            <div className="row g-4">
              <div className="col-12">
                <div className="carding border rounded p-4 about-section-card h-100">
                  <FaLightbulb className="me-2 " size={24} />
                  <h4 className="mb-3">Innovation</h4>
                  <p className="mb-3">
                    Driving progress through creative and cutting-edge
                    solutions.
                  </p>
                  <Link className="fw-semibold text-decoration-none text-navyblue" to="/about">
                    Read More <i className="fa fa-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>

              <div className="col-12">
                <div className="carding border rounded p-4 about-section-card h-100">
                  <FaShieldAlt className="me-2 " size={24} />
                  <h4 className="mb-3">Integrity</h4>
                  <p className="mb-3">
                    Building trust with transparency, honesty, and
                    accountability.
                  </p>
                  <Link className="fw-semibold text-decoration-none text-navyblue" to="/about">
                    Read More <i className="fa fa-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="carding border rounded p-4 about-section-card h-100">
              <FaTrophy className="me-2 " size={24} />
              <h4 className="mb-3">Excellence</h4>
              <p className="mb-3">
                Committed to delivering unmatched quality and superior results.
              </p>
              <Link className="fw-semibold  text-decoration-none text-navyblue" to="/about">
                Read More <i className="fa fa-arrow-right ms-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
